<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    width: 120px;
    white-space: nowrap;

    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    // min-width: 260px;
    width: 100%;
    text-align: right;
    margin-left: 20px;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
</style>

<template>
  <div class="detail-content-div">
    <el-row :gutter="30">
      <div class="title-div">
        共享开关信息
        <el-dropdown @command="handleCommand">
          <div class="flex-r header-dropdown">
            <p class="header-container-name">{{ detailForm.deviceCode }}</p>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="i in pileList" :key="i.pileCode" :command="i.pileCode">{{ i.pileCode }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex" style="font-weight: 600;font-size: 18px;">基础信息</el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">设备编号</div>
        <div>{{ detailForm.deviceCode }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">设备名称</div>
        <div>{{ detailForm.shareStationName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">设备型号</div>
        <div>{{ detailForm.typeName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">是否开通共享</div>
        <div>{{ detailForm.shareActiveName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">当前共享状态</div>
        <div>{{ detailForm.shareModeName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">共享开关实时状态</div>
        <div>{{ detailForm.shareLocalStatusName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">共享列表状态</div>
        <div>{{ detailForm.shareListLocalStatus }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">绑定渠道</div>
        <div>{{ detailForm.bindChannelName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">所属用户</div>
        <div>{{ detailForm.custMobile }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">绑定时间</div>
        <div>{{ detailForm.bindTime }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">最近订单开始时间</div>
        <div>{{ detailForm.lastOrderTime }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">剩余补贴发放时间</div>
        <div>{{ detailForm.endDisbursementTime }}</div>
      </el-col>
      
      <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex" style="font-weight: 600;font-size: 18px;">参数信息</el-col>

      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">厂家/厂商代码</div>
        <div>{{ detailForm.manufactureCode }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">绑定方式</div>
        <div style="color:#4182EB">{{ detailForm.firstChargeDate }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">联网方式</div>
        <div style="color:#4182EB">{{ detailForm.onlineConnectType }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">电流采集</div>
        <div style="color:#4182EB">{{ detailForm.currentValueCollect }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">电压采集</div>
        <div style="color:#4182EB">{{ detailForm.voltageValueCollect }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">电量采集</div>
        <div style="color:#4182EB">{{ detailForm.powerDataCollect }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">温度采集</div>
        <div style="color:#4182EB">{{ detailForm.tempDataCollect }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">保护功能</div>
        <div style="color:#4182EB">{{ detailForm.protectFunction }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">指示灯</div>
        <div style="color:#4182EB">{{ detailForm.signalLight }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">支持协议</div>
        <div style="color:#4182EB">{{ detailForm.connectProtocol }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">设备图片</div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <img src="https://zd-app-data.oss-cn-shanghai.aliyuncs.com/static/kaiguanshebei.png" style="width: 80px; height: 80px; cursor: pointer;" @click="dialogVisible = true" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex" style="font-weight: 600;font-size: 18px;">激活账单</el-col>
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column prop="totalFee" label="购买订单编号" width="200" align="center" />
        <el-table-column prop="pileCodes" label="用户手机号" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买类型" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买名称" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买内容" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买金额" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买时间" width="200" align="center" />
        <el-table-column prop="pileCodes" label="支付方式" width="200" align="center" />
        <el-table-column prop="pileCodes" label="交易流水号" width="200" align="center" />
      </el-table>
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </el-row>
    <!-- 图片放大对话框 -->
    <el-dialog :visible.sync="dialogVisible" width="600px" :modal-append-to-body="false">
      <img :src="imageUrl" style="width: 100%; height: auto;" />
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      isFlag: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      pagination: pageConfig.detailPagination,
      // 默认值设置
      detailForm: {},
      pileList: [],
      custInfo: {},
      queryInfo: {
        pageNum: 1,
        total: 0,
      },
      dialogVisible: false, // 控制图片放大对话框显示
      imageUrl: 'https://zd-app-data.oss-cn-shanghai.aliyuncs.com/static/kaiguanshebei.png' // 图片URL
    }
  },
  methods: {
    handleCommand(val) {
      let _ = this;
      _.custInfo.pileCode = val;
      _.getListData(_.pagination, true)
    },
    init() {
      let _ = this;
      if (_.$store.state.custObj) {
        _.custInfo = _.$store.state.custObj;
        _.getListData(_.pagination, true)
      }
    },
    getListData(pagination, reload = false) {
      let _ = this;
      console.log('111')
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      const params = {
        deviceCode: _.custInfo.pileCode,
        deviceType: _.custInfo.deviceType
      }
      _.$H.post(_, _.$A.digitization.getShareDeviceInfo, params).then(res => {
        _.detailForm = res.data.data || {};
      })

      const dataparams = {
        ...params,
        ..._.queryInfo
      }
      _.$H.post(_, _.$A.digitization.getShareDevicePage, dataparams).then(res => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      })

    },
  },
  mounted() {
    this.init()
  },
}
</script>
